import React from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';
import { ContractDocusignSendHistoryDto } from '../../services/contracts/ContractService';
import DocusignHistoryEntry from './DocusignHistoryEntry';

interface DocusignSendHistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  history: ContractDocusignSendHistoryDto[];
  contractId: string;
}

const DocusignSendHistoryModal: React.FC<DocusignSendHistoryModalProps> = ({
  isOpen,
  onClose,
  history,
  contractId,
}) => (
  <Modal open={isOpen} onClose={onClose} size="large">
    <Modal.Header>
      <Icon name="file alternate" />
      Histórico completo DocuSign
    </Modal.Header>
    <Modal.Content scrolling style={{ maxHeight: '70vh' }}>
      {history.length === 0 ? (
        <p style={{ color: '#666' }}>Nenhum envio DocuSign registrado para o contrato {contractId}.</p>
      ) : (
        history.map((item, index) => (
          <DocusignHistoryEntry
            key={item.id}
            item={item}
            index={index}
            isLast={index === history.length - 1}
          />
        ))
      )}
    </Modal.Content>
    <Modal.Actions>
      <Button onClick={onClose} primary>
        <Icon name="check" />
        Fechar
      </Button>
    </Modal.Actions>
  </Modal>
);

export default DocusignSendHistoryModal;
